import { computed } from 'vue'

import { useBuybackCategories } from '@backmarket/nuxt-layer-buyback/app/scopes/offer/composables/useBuybackCategories/useBuybackCategories'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import type { Bread } from '@ds/components/Breadcrumbs/Breadcrumbs.vue'

import { CMS } from '~/scopes/cms/routes-names'

import translations from './useSeoBreadcrumb.translations'

function getLinkByCategory(category: string, brand: string) {
  switch (category) {
    case 'smartphone':
      return brand === 'Apple'
        ? {
            name: CMS.BUYBACK_CATEGORY,
            params: { pageName: 'smartphones', pageCategory: 'iphone' },
          }
        : { name: CMS.BUYBACK, params: { pageName: 'smartphones' } }
    case 'tablet':
      return { name: CMS.BUYBACK, params: { pageName: 'tablets' } }
    case 'macbook':
      return { name: CMS.BUYBACK, params: { pageName: 'macbook' } }
    case 'gaming-console':
      return { name: CMS.BUYBACK, params: { pageName: 'consoles' } }
    case 'audio':
      return { name: CMS.BUYBACK, params: { pageName: 'audio' } }
    default:
      return { name: CMS.BUYBACK, params: { pageName: 'home' } }
  }
}

export function useSeoBreadcrumb(
  category: string,
  brand: string,
  model: string,
) {
  const i18n = useI18n()
  const { getTitleByCategory } = useBuybackCategories()

  const breads = computed<Bread[]>(() => [
    {
      title: i18n(translations.breadcrumbHome),
      link: { name: CMS.BUYBACK, params: { pageName: 'home' } },
    },
    {
      title: getTitleByCategory(
        category === 'smartphone' && brand === 'Apple' ? brand : category,
      ),
      link: getLinkByCategory(category, brand),
    },
    {
      title: model,
      link: {},
    },
  ])

  return {
    breads,
  }
}
